import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/polymarket/")({
  beforeLoad: () => {
    throw redirect({ to: "/prediction-markets", replace: true });
  },
});
